import axios from "axios";
import { sendAuthorizationRequest } from "../services/login";
// Francisco - Adicionando importação do cookie
import { getCookie } from "../utils/cookies";

const api = axios.create(
    process.env.REACT_APP_ENVIRONMENT !== "TESTE" ?
        {
            baseURL: process.env.REACT_APP_API,
            // Francisco - Removido, pois agora está usando cookies
            // headers: {
            //     Authorization: `${localStorage.getItem("access_token")}`
            // }
        } :
        {
            baseURL: process.env.REACT_APP_API
        });

// Francisco - Adicionando interceptors para tratamento de erro 
// ⏳Para injetar Authorization header antes da request
api.interceptors.request.use((config) => {
    // Francisco
    // const token = getCookie("ACCESS_TOKEN"); -- original
    let token = getCookie("ACCESS_TOKEN");

    if (!token) {
        token = localStorage.getItem("access_token");
    }
    // fim

    if (token) {
        config.headers.Authorization = token;
        //config.headers.Authorization = `Bearer ${token}`;
        // Francisco
    } else {
    }
    return config;
});

export function get<T = unknown>(url: string) {
    return api.get(url).then((data) => {
        if (data.status === 200 || data.status === 201) {
            data.data.codeStatus = data.status;
            return data.data
        }
    }).catch((err) => {
        if (process.env.REACT_APP_ENVIRONMENT !== "TESTE") {
            if (err.response.data === undefined) {
                sendAuthorizationRequest();
            }
        }
        return err.response.data;
    }).finally(() => false);
}

export function post<T = unknown>(url: string, options?: any) {
    return api.post(url, options).then((data) => {
        if (data.status === 200 || data.status === 201) {
            data.data.codeStatus = data.status;
            return data.data
        }
    }).catch((err) => {
        if (process.env.REACT_APP_ENVIRONMENT !== "TESTE") {
            if (err.response.data === undefined) {
                sendAuthorizationRequest();
            }
        }
        return err.response.data;
    }).finally(() => false);
}

export function put<T = unknown>(url: string, options?: any) {
    return api.put(url, options).then((data) => {
        if (data.status === 200) {
            data.data.codeStatus = data.status;
            return data.data
        }
    }).catch((err) => {
        if (process.env.REACT_APP_ENVIRONMENT !== "TESTE") {
            if (err.response.data === undefined) {
                sendAuthorizationRequest();
            }
        }
        return err.response.data;
    }).finally(() => false);
}

export function deleteR<T = unknown>(url: string, options?: any) {
    return api.delete(url, options).then((data) => {
        if (data.status === 200) {
            data.data.codeStatus = data.status;
            return data.data
        }
    }).catch((err) => {
        if (process.env.REACT_APP_ENVIRONMENT !== "TESTE") {
            if (err.response.data === undefined) {
                sendAuthorizationRequest();
            }
        }
        return err.response.data;
    }).finally(() => false);
}